import * as R from "ramda";
import lens from "../lenses/import-status-report";

export default {
  root: R.view(lens),
  data: R.view(lens.data),
  hasInitiated: R.view(lens.hasInitiated),
  loading: R.view(lens.loading),
};
